import { CircleCheck } from 'lucide-react';
import { useEffect, useRef } from 'react';

function useNotifyParentOnFinish(enabled) {
  const hasPostedRef = useRef(false);
  const params = new URLSearchParams(window.location.search);
  const parentOrigin = params.get('parentOrigin') || '*';

  useEffect(() => {
    if (!enabled) return;
    if (hasPostedRef.current) return;

    window.parent.postMessage(
      {
        type: 'REACT_FLOW',
        status: 'FINISH'
      },
      parentOrigin
    );

    hasPostedRef.current = true;
  }, [enabled, parentOrigin]);
}

export function SucessoProcessoReact() {
  useNotifyParentOnFinish(true);

  return (
    <div className='content'>
      <div className='content-liveness'>
        <div className='header'>Validação</div>
        <div className='content-success'>
          <CircleCheck color='#3AA857' strokeWidth={2} size={150}/>
          <span>Tudo certo com a verificação da sua identidade!</span>
          <span className='sub-success'>Aguarde um momento para seguir para as próximas etapas.</span>
        </div>
      </div>
    </div>
  );
}
